import * as React from 'react';
import BeautyStars from 'beauty-stars';


interface ParentProps {
    toggleFn: any;
    updateRatingValue: any;
    rateStars: boolean;
    locale: string,
    closedRatingFn: any;
    chatbotsettings: any
}

interface RatingProps {
    ratingValue: any;
    ratingSubmitted: boolean;
    feedbackSubmitted: boolean;
    rateStars: boolean;
    showFeedback: boolean;
    feedbackMsg: string;
    ratingLevel?: string,
    ratingText?: string;
    submitRatingText?: string;
    submitFeedbackText?: string;
    feedbackLevel?: string;
    feedbackThankyou?: string;
    closeChatText?: string;
    ratingSkipped: boolean; // added by yashesh
    skipRatingText?: string;
    txtPlaceholder?: string;
}


export class RatingStars extends React.Component<ParentProps, RatingProps> {
    state: RatingProps = {
        ratingValue: 0,
        ratingSubmitted: false,
        rateStars: false,
        feedbackSubmitted: false,
        showFeedback: false,
        feedbackMsg: '',
        ratingSkipped: false // added by yashesh

    };

    updateStarsShowFn = () => {
        this.setState({ rateStars: !this.state.rateStars })
    }

    inputOnchange = (fieldValue: string) => {
        this.setState({ feedbackMsg: fieldValue })
    }
    getRatingValueFn = () => {
        return this.state.ratingValue
    }

    showRatingFn = () => {
        this.props.closedRatingFn(this.state);
        this.setState({
            ratingValue: 0,
            ratingSubmitted: false,
            rateStars: false,
        })
    }

    submitRatingFn = () => {
        //this.props.updateRatingValue(this.state);
        this.setState({ ratingSubmitted: true, showFeedback: true })
    }


    submitFeebackFn = () => {
        this.setState({ ratingSubmitted: true, feedbackSubmitted: true })
    }

    closeChatFn = () => {
        this.props.updateRatingValue(this.state);
        this.setState({
            ratingValue: 0,
            ratingSubmitted: false,
            feedbackSubmitted: false,
            rateStars: false,
            feedbackMsg: ''
        })

    }

    closeChatPopupFn = () => {
        this.state.ratingValue = 0;
        this.props.updateRatingValue(this.state);
        this.setState({
            ratingValue: 0,
            ratingSubmitted: false,
            feedbackSubmitted: false,
            rateStars: false,
            feedbackMsg: ''
        })
    }


    async componentDidMount() {
        // GET request using fetch with async/await
        const response = await fetch(this.props.chatbotsettings.configvaluesurl, {
            headers: {
                'ApiKey': this.props.chatbotsettings.configvaluesurlapikey,
                'Content-type': 'application/json'
            },
            method: 'GET'

        });

        const data = await response.json();
        if (this.props.locale === 'fr') {

            this.state.ratingLevel = data.filter((list: any) => list.referenceKey === 'feedbackFlowRating')[0].frenchMessage;
            this.state.ratingText = data.filter((list: any) => list.referenceKey === 'Rate Conversation')[0].frenchMessage;
            this.state.submitRatingText = data.filter((list: any) => list.referenceKey === 'Submit Rating')[0].frenchMessage;
            this.state.closeChatText = data.filter((list: any) => list.referenceKey === 'Close Chat')[0].frenchMessage;
            this.state.skipRatingText = data.filter((list: any) => list.referenceKey === 'SkipRating')[0].frenchMessage;

            this.state.feedbackLevel = data.filter((list: any) => list.referenceKey === 'feedbackFlowFeedback')[0].frenchMessage;
            this.state.submitFeedbackText = data.filter((list: any) => list.referenceKey === 'Submit Feedback')[0].frenchMessage;
            this.state.feedbackThankyou = data.filter((list: any) => list.referenceKey === 'feedbackThankyou')[0].frenchMessage;
            this.state.txtPlaceholder = data.filter((list: any) => list.referenceKey === 'feedbackOptional')[0].frenchMessage;
        }
        else {


            this.state.ratingLevel = data.filter((list: any) => list.referenceKey === 'feedbackFlowRating')[0].message;
            this.state.ratingText = data.filter((list: any) => list.referenceKey === 'Rate Conversation')[0].message;
            this.state.submitRatingText = data.filter((list: any) => list.referenceKey === 'Submit Rating')[0].message;
            this.state.closeChatText = data.filter((list: any) => list.referenceKey === 'Close Chat')[0].message;
            this.state.skipRatingText = data.filter((list: any) => list.referenceKey === 'SkipRating')[0].message;

            this.state.feedbackLevel = data.filter((list: any) => list.referenceKey === 'feedbackFlowFeedback')[0].message;
            this.state.submitFeedbackText = data.filter((list: any) => list.referenceKey === 'Submit Feedback')[0].message;
            this.state.feedbackThankyou = data.filter((list: any) => list.referenceKey === 'feedbackThankyou')[0].message;
            this.state.txtPlaceholder = data.filter((list: any) => list.referenceKey === 'feedbackOptional')[0].message;
        }
    }

    render() {

        return (
            <div>
                {this.state.rateStars ?

                    <div className="ratingPopup popup">
                        <div className="overlay popup-overlay"></div>
                        <div className="rating-container popup-container">
                            <div className="rating-content popup-content">
                                <div className="rating-top popup-top">
                                    <a title="Close Rating" className="close-btn"
                                        onClick={this.closeChatPopupFn} href="#"><i className="fa fa-close" ></i></a>
                                    <p> {this.state.ratingLevel}</p>
                                </div>
                                <div className="stars-container popupContent-container">

                                    <span className="logo-container d-flex">
                                        <img className='bot-header-image'
                                            src={this.props.chatbotsettings.chaticonurl} alt='Bot image' />
                                    </span>



                                    {!this.state.ratingSubmitted ?
                                        <div>
                                            <p>{this.state.ratingText}</p>
                                            <BeautyStars
                                                value={this.state.ratingValue} size="30px" inactiveColor="#808080"
                                                onChange={ratingValue => this.setState({ ratingValue })}>
                                            </BeautyStars>
                                            {this.state.ratingValue ?
                                                <button
                                                    onClick={this.submitRatingFn}
                                                    className="btn btn-primary">{this.state.submitRatingText}</button> :
                                                <button

                                                    onClick={this.closeChatFn}

                                                    className="btn btn-primary">{this.state.skipRatingText}</button>

                                            }
                                            {/*added by yashesh*/}
                                            {/*<button onClick={this.closeChatFn} className="btn btn-primary">{this.state.skipRatingText}</button>*/}
                                        </div>
                                        : ''}
                                    {this.state.ratingSubmitted && !this.state.feedbackSubmitted ?
                                        <div className="stars-container">
                                            <p>
                                                {this.state.feedbackLevel}
                                                {/*<span>(Optional)</span>*/}
                                            </p>
                                            <textarea value={this.state.feedbackMsg} className="text-area" placeholder={this.state.txtPlaceholder}

                                                onChange={(
                                                    ev: React.ChangeEvent<HTMLTextAreaElement>,
                                                ): void => this.inputOnchange(ev.target.value)}></textarea>
                                            <button
                                                onClick={this.submitFeebackFn}
                                                type="submit" className="btn btn-primary">{this.state.submitFeedbackText}</button>
                                        </div>
                                        : ''}

                                    {this.state.ratingSubmitted && this.state.feedbackSubmitted ?
                                        <div className="stars-container">  <p> {this.state.feedbackThankyou} </p>
                                            <button
                                                onClick={this.closeChatFn}
                                                type="submit" className="btn btn-primary">{this.state.closeChatText}</button>
                                        </div>
                                        : ''}
                                </div>


                            </div>
                        </div>
                    </div>


                    : ''}

            </div>
        );
    }
}
export default RatingStars;
